import { AddItemController } from "./add-item.controller";
import { ImportDialogController } from "./import-dialog.controller";
import { NewItemDialogController } from "./new-item-dialog.controller";

import { ImportMediaService } from "./import-media.service";
import { ImportPasserelleService } from "./import-passerelle.service";
import { ImportSaleItemsService } from "./import-sale-items.service";
import { ImportSaleResultService } from "./import-sale-result.service";


angular
    .module("thor.sales.edit.add-item.component", [])
    .component("addItem", {
        bindings: {
            sale: "<"
        },
        controller: AddItemController,
        controllerAs: "addItemCtrl"
    })
    .service("importMedia", ImportMediaService)
    .service("importPasserelle", ImportPasserelleService)
    .service("importSaleItems", ImportSaleItemsService)
    .service("importSaleResult", ImportSaleResultService)
    .controller("ImportDialogController", ImportDialogController)
    .controller("NewItemDialogController", NewItemDialogController);
